<template>
	<div class="main-container">
        <Navbar v-bind:isTarget="false"/>
        <!-- offcanvas search component -->
        <OffcanvasSearchBox />
        <div class="software-accordion-wrapper section-space--pt_120 section-space--pb_60 gray-gradient">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div>
                            <b-link v-bind:href="'#dfCategory'+index" v-for="(data, index) in DataDefinition" v-bind:key="index" class="margin-right-50">•&nbsp;&nbsp;{{data.category}}</b-link>
                        </div>
                        <b-input-group class="mt-3 margin-bottom-20">
                            <b-form-input v-model="searchText" class="height-54"></b-form-input>
                            <button variant="info" class="search-faq height-54" @click="searchFaq()"><i class="far fa-search font-size-20 vertical-align-middle"></i></button>
                        </b-input-group>
                        <hr class="margin-top-60 margin-bottom-0" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="faq-wrapper">
                            <div class="accordion-faq wow move-up">
                                <div v-for="(data, tindex) in DataDefinition" v-bind:key="tindex" class="padding-top-60" v-bind:id="'dfCategory' + tindex">
                                    <h6 class="margin-vertical-30">{{data.category}}</h6>
                                    <b-card no-body v-for="(df, index) in data.data" v-bind:key="index">
                                        <b-card-header header-tag="header">
                                            <b-button block v-b-toggle="'id'+data.category+df.title" class="faq-title" v-bind:id="data.category+df.title">{{df.title}}</b-button>
                                        </b-card-header>
                                        <b-collapse :id="'id'+data.category+df.title" v-model="df.visible">
                                            <b-card-body class="padding-top-0">
                                                <b-card-text class="white-space-pre-wrap">{{df.content}}</b-card-text>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CurveShape class="curve-bottom">
            <template v-slot:bgcolor>
                <path style="fill: #CBCDCB;
                    stroke-miterlimit:10;" 
                    d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"/>
            </template>
        </CurveShape>
    </div>
</template>

<script>
	import CurveShape from "../components/CurveShape";
    import Navbar from "../components/Navbar";
    import OffcanvasSearchBox from "@/components/OffcanvasSearchBox";
    import DataDefinition from '../assets/consts/DataDefinition';

	export default {
		name: "app",
		components: {
			CurveShape,
            Navbar,
            OffcanvasSearchBox
		},
        data (){
            return {
                DataDefinition: DataDefinition,
                searchText: '',
                form: {
                    nickname: '',
                    email: '',
                    content: '',
                    file: null,
                },
                show: true
            }
        },
        metaInfo: {
            title: 'CREIS Japan - FAQ',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        },
        mounted() {
            const targetAnchor = document.querySelector(`#${this.$route.query.category}${this.$route.query.name}`)
            const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
            const originalTop = distanceToTop(targetAnchor);
            window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
            this.$root.$emit('bv::toggle::collapse', `id${this.$route.query.category}${this.$route.query.name}`)
        },
        methods: {
            searchFaq() {
                for (const key in this.DataDefinition) {
                    if (this.DataDefinition.hasOwnProperty(key)) {
                        const element = this.DataDefinition[key]
                        element.data.forEach(f => {
                            if(this.searchText.trim() === '') {
                                f.visible = false
                            } else {
                                f.visible = (f.title.includes(this.searchText.trim()) || f.content.includes(this.searchText.trim())) ? true : false
                            }
                        });
                    }
                }
            },
            onSubmit(event) {
                event.preventDefault()
                // alert(JSON.stringify(this.form))
            },
            onReset(event) {
                event.preventDefault()
                // Reset our form values
                this.form.nickname = ''
                this.form.email = ''
                this.form.content = ''
                this.form.file = null
                // Trick to reset/clear native browser form validation state
                this.show = false
                this.$nextTick(() => {
                    this.show = true
                })
            }
        }
	};
</script>